<div class="caption__wrapper--buttons" [formGroup]="controlContainer.control">
  <div class="button__wrapper">
    <mat-chip-list
      multiple
      #chipList
      aria-label="Quick Reply selection"
      [formControlName]="controlName"
    >
      <mat-chip
        *ngFor="let chip of chips; let chipIdx = index"
        selectable="true"
        (click)="toggleQuickReplyFilter(chipIdx)"
        [ngStyle]="{
          borderColor: chip?.color,
          color:
            chip.isSelected || selectedChips.has(chip.value)
              ? '#ffff'
              : chip?.color,
          backgroundColor:
            chip.isSelected || selectedChips.has(chip.value)
              ? chip?.color
              : ''
        }"
        [ngClass]="[
          'chip-outlined-' + chip.type,
          (chip.isSelected || selectedChips.has(chip.value))
            ? 'chip-contained-' + chip.type
            : ''
        ]"
      > 
        <span> {{ chip.label }}</span>
        <span *ngIf="chip.total >= 0 && isCountVisible">
          ({{ chip.total }})</span
        >
      </mat-chip>
    </mat-chip-list>
    <ng-content></ng-content>
    <!-- <img src="assets/svg/Filter-Icon.svg" alt="filter" /> -->
  </div>
</div>
